"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const base_models_1 = require("@integration/base-models");
class OfferFeedbackMetadataV2 extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsUUID)(),
    (0, base_models_1.Docs)({ example: 'f1a083b7-100d-4401-afbd-998ad26b2db9', description: 'ID of the chosen incentive.' }),
    tslib_1.__metadata("design:type", String)
], OfferFeedbackMetadataV2.prototype, "incentiveId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '448700', description: 'ID of the BAC/Retention flow.' }),
    tslib_1.__metadata("design:type", String)
], OfferFeedbackMetadataV2.prototype, "flowId", void 0);
exports.default = OfferFeedbackMetadataV2;
